# 管理成员全局通用组件

$ ->
  $(document).on 'click', '.manage-members-tabs .tab-header', ->
    $link = $(@)
    return  if $link.hasClass 'active'

    $link.addClass('active')
      .siblings()
      .removeClass('active')
      .closest('.manage-members-tabs')
      .find('.tab:visible')
      .fadeOut 'fast', ->
        $(@).siblings("[data-tab=#{ $link.data('tab') }]")
          .fadeIn 'fast'


$.extend tower,
  initManageMembers: (el, updateMembers = false, visitorLock = false) ->
    el.find('.manage-members').each ->
      wrapper = $(@)
      $select = wrapper.find('#select-add-member')
      $members = wrapper.find('.members .member')

      return  unless wrapper.length and $members.length

      addMember = simple.select
        el: $select
        placeholder: '点击添加成员'
        onItemRender: ($itemEl, item) ->
          $span = $('.label', $itemEl)
          $('<img>').attr('src',item.gavatar).addClass('avatar').insertBefore($span)
          $itemEl

      # FIX: 防止浏览器自动填充
      addMember.disable()
      setTimeout ->
        addMember.clearSelection()
        addMember.enable()
      , 1000

      # FIXME: simple-select requireSelect 参数不可配置
      addMember.requireSelect = false
      addMember.clearSelection()

      addMember.on 'select', (e, item) ->
        $member = $members.filter("[data-guid=#{ item.guid }]")
        showMember $member
        tower.highlight $member
        addMember.clearSelection()
        refreshGroup(wrapper)

      wrapper.on 'change', '.member input[type="checkbox"]', memberClick
        .on 'click', '.group-select span[data-subgroup]', groupClick

      refreshGroup(wrapper)

      if updateMembers
        memberGuids = $select.data('member-guids').split(',') || []
        tower.updateManageMembers(wrapper, memberGuids, visitorLock)


  updateManageMembers: (wrapper, guids, visitorLock, removeDisabled = true) ->
    return []  unless guids.length

    wrapper.toggleClass('visitor-locked', visitorLock)
    addMember = wrapper.find('.simple-select').data('select')

    return []  unless addMember

    members = []
    $members = wrapper.find('.members .member')
    if removeDisabled
      $members.removeClass('disabled')

    $members.each ->
      m = $(@)

      if (m.data('guid') in guids) and (not visitorLock or not m.is('.visitor'))
        members.push
          label: m.find('.name').text()
          key: m.data('shortcut-key')
          guid: m.data('guid')
          subgroup: m.data('subgroup')
          gavatar: m.find('img').attr('src') || m.data('gavatar')
      else
        m.addClass('disabled')
        hideMember(m)

    addMember.setItems(members)
    refreshGroup(wrapper)
    return members


  disableManageMembers: (wrapper) ->
    wrapper.addClass('disabled')

    addMember = wrapper.find('.simple-select').data('select')
    addMember.disable() if addMember


  initManageMembersTabs: ($el) ->
    if $el.find('.tab-header').length is 1
      $el.find('.tabs-header').remove()

    $el.find('.tab-header:first, .tab:first').addClass 'active'
    $el.find('.manage-members').on 'memberchange', ->
      $link = $el.find('.tab-header[data-tab=team]')
      return  unless $link.length

      count = $el.find('.members input[type="checkbox"]:checked').length
      count = if count then " (#{ count })" else ''
      $link.text "团队成员#{ count }"



memberClick = (e) ->
  target = $(e.target).closest('.member')
  wrapper = target.closest('.manage-members')

  return if wrapper.hasClass('disabled')

  if target.hasClass('selected')
    hideMember target
  else
    showMember(target)


groupClick = (e) ->
  target = $(@)
  wrapper = target.closest('.manage-members')

  return if wrapper.hasClass('disabled')

  subgroupId = target.data('subgroup')
  members = wrapper.find('.members .member:not(.disabled)')

  if subgroupId isnt -1
    members = members.filter("[data-subgroup*=#{ subgroupId }]")

  if wrapper.hasClass('visitor-locked')
    members = members.filter ->
      return not $(@).hasClass('visitor')

  if target.hasClass('selected')
    hideMember members
  else
    showMember(members)


hideMember = ($member, callback) ->
  wrapper = $member.closest('.manage-members')
  $member.removeClass('selected')
  $member.find('input[type="checkbox"]').prop('checked', false)
  refreshGroup(wrapper)
  callback?()


showMember = ($member) ->
  return if $member.hasClass('disabled') || $member.hasClass('unselectable')

  wrapper = $member.closest('.manage-members')
  $member.addClass('selected')
  $member.find('input[type="checkbox"]').prop('checked', true)
  refreshGroup(wrapper)


refreshGroup = (wrapper) ->
  allMembers = wrapper.find('.member:not(.disabled)')
  unselectableGroupIds = allMembers.filter('.unselectable')
                          .map((i, member) -> $(member).data('subgroup')).get()
                          .filter((group, i, groups) -> groups.indexOf(group) == i)

  wrapper.find('.group-select span[data-subgroup]').each ->
    btn = $(@)
    groupId = btn.data('subgroup')
    members = allMembers

    if groupId isnt -1
      members = members.filter("[data-subgroup*=#{ groupId }]")

    btn.removeClass('unselectable')

    if members.length
      btn.show()

      if unselectableGroupIds.indexOf(groupId) > -1
        btn.addClass('unselectable')
      else
        btn.toggleClass('selected', !members.filter(':not(.selected)').length)
    else
      btn.hide()

  wrapper.find('.group-select span.all[data-subgroup]').addClass('unselectable') if unselectableGroupIds.length
  wrapper.trigger('memberchange')
